import {
  IconButton as MuiIconButton,
  type IconButtonProps as MuiIconButtonProps,
} from '@mui/material';
import { useThemeTokens } from '@providers/themeTokenProvider';
import { Tooltip } from '../tooltip/tooltip';

interface IconButtonProps extends Omit<MuiIconButtonProps, 'size'> {
  label?: string;
  testId?: string;
  size?: 'xsmall' | MuiIconButtonProps['size'];
}

const pixelBySize = new Map<IconButtonProps['size'], string>()
  .set('small', '24px')
  .set('xsmall', '20px');

export const IconButton = (props: IconButtonProps) => {
  const { sys } = useThemeTokens();

  const pixelSize = pixelBySize.get(props.size) || '40px';

  if (props.label) {
    return (
      <Tooltip title={props.label} placement='top'>
        <MuiIconButton
          data-testid={props.testId}
          sx={{
            height: pixelSize,
            color: sys.color.onSurface,
            width: pixelSize,
            ...props.sx,
          }}
          {...(props as MuiIconButtonProps)}
        />
      </Tooltip>
    );
  }

  return (
    <MuiIconButton
      data-testid={props.testId}
      sx={{
        height: pixelSize,
        color: sys.color.onSurface,
        width: pixelSize,
        ...props.sx,
      }}
      {...(props as MuiIconButtonProps)}
    />
  );
};
